import type { StokOzet as StokOzetType } from "@/api/stok";
import { t } from "@/i18n";
import { fmtInt } from "@/lib/utils";

/** Ust ozet seridi — kritik/yakin/az satan/cok satan sayilari (sozlesme §3). */
export function StokOzet({ ozet }: { ozet: StokOzetType }) {
  return (
    <div className="grid grid-cols-2 gap-3 xl:grid-cols-4">
      <div className="kpi kpi-bad">
        <p className="kpi-lbl">{t("stok.ozet.kritik")}</p>
        <p className="kpi-val mt-2">{fmtInt(ozet.kritik_sayisi)}</p>
        <p className="kpi-sub">{t("stok.ozet.kritik_sub")}</p>
      </div>
      <div className="kpi kpi-warn">
        <p className="kpi-lbl">{t("stok.ozet.yakin")}</p>
        <p className="kpi-val mt-2">{fmtInt(ozet.yakin_sayisi)}</p>
        <p className="kpi-sub">{t("stok.ozet.yakin_sub")}</p>
      </div>
      <div className="kpi kpi-warn">
        <p className="kpi-lbl">{t("stok.ozet.az_satan")}</p>
        <p className="kpi-val mt-2">{fmtInt(ozet.az_satan_sayisi)}</p>
        <p className="kpi-sub">{t("stok.ozet.az_satan_sub")}</p>
      </div>
      <div className="kpi kpi-ok">
        <p className="kpi-lbl">{t("stok.ozet.cok_satan")}</p>
        <p className="kpi-val mt-2">{fmtInt(ozet.cok_satan_sayisi)}</p>
        <p className="kpi-sub">{t("stok.ozet.toplam_satis", { adet: fmtInt(ozet.toplam_satilan) })}</p>
      </div>
    </div>
  );
}
